import { render, staticRenderFns } from "./BaseTruncateLabel.vue?vue&type=template&id=6eb40616&scoped=true"
import script from "./BaseTruncateLabel.vue?vue&type=script&lang=js"
export * from "./BaseTruncateLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb40616",
  null
  
)

export default component.exports